import { render, staticRenderFns } from "./assetStock.vue?vue&type=template&id=280801b1&scoped=true"
import script from "./assetStock.vue?vue&type=script&lang=js"
export * from "./assetStock.vue?vue&type=script&lang=js"
import style0 from "./assetStock.vue?vue&type=style&index=0&id=280801b1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280801b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('280801b1')) {
      api.createRecord('280801b1', component.options)
    } else {
      api.reload('280801b1', component.options)
    }
    module.hot.accept("./assetStock.vue?vue&type=template&id=280801b1&scoped=true", function () {
      api.rerender('280801b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workOrder/asset/assetStock.vue"
export default component.exports